export const ROM_ROOT_LINK_ID = "rom";

export const ROM_DATE_TIME_LINK_ID = "romDateTime";
export const ROM_DATE_LINK_ID = "romDate";
export const ROM_TIME_LINK_ID = "romTime";

export const ROM_METHOD_LINK_ID = "romMethod";
export const ROM_CONFIRMED_BY_LINK_ID = "romConfirmedBy";
export const ROM_CONFIRMED_BY_OTHER_LINK_ID = "romConfirmedByOther";
export const ROM_FLUID_COLOR_LINK_ID = "romFluidColor";
export const ROM_FLUID_COLOR_OTHER_LINK_ID = "romFluidColorOther";
export const ROM_NOTES_LINK_ID = "romNotes";
export const ROM_SIGNATURE_INITIALS_LINK_ID = "romSignatureInitials";

export const ROM_QUESTIONNAIRE_NAME = "rupture_of_membranes";
